import WalletModel from '@/api/models/WalletModel';
import httpClient from '../../httpClient';
import ErrorModel from '@/api/models/ErrorModel';

export const getWalletData = (): Promise<WalletModel | ErrorModel> => {
  return httpClient
    .get(`/partners/wallet`)
    .then((response) => new WalletModel(response))
    .catch((error) => error);
};
